module.exports = __webpack_public_path__ + "assets/img/newG04.60de6dbf.png";